import React from 'react';

const MessageIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3332 3.33325H1.6665V16.6666H18.3332V3.33325ZM16.6665 6.66659L9.99984 10.8333L3.33317 6.66659V4.99992L9.99984 9.16658L16.6665 4.99992V6.66659Z"
        fill="#CE181E"
      />
    </svg>
  );
};

export default MessageIcon;
